/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuditEventHourCountResponse
 */
export interface AuditEventHourCountResponse {
    /**
     * 
     * @type {any}
     * @memberof AuditEventHourCountResponse
     */
    weekday?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventHourCountResponse
     */
    hour?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventHourCountResponse
     */
    count?: any | null;
}

/**
 * Check if a given object implements the AuditEventHourCountResponse interface.
 */
export function instanceOfAuditEventHourCountResponse(value: object): value is AuditEventHourCountResponse {
    return true;
}

export function AuditEventHourCountResponseFromJSON(json: any): AuditEventHourCountResponse {
    return AuditEventHourCountResponseFromJSONTyped(json, false);
}

export function AuditEventHourCountResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventHourCountResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'weekday': json['weekday'] === undefined ? undefined : json['weekday'] === null ? null : json['weekday'],
        'hour': json['hour'] === undefined ? undefined : json['hour'] === null ? null : json['hour'],
        'count': json['count'] === undefined ? undefined : json['count'] === null ? null : json['count'],
    };
}

export function AuditEventHourCountResponseToJSON(json: any): AuditEventHourCountResponse {
    return AuditEventHourCountResponseToJSONTyped(json, false);
}

export function AuditEventHourCountResponseToJSONTyped(value?: AuditEventHourCountResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'weekday': value['weekday'],
        'hour': value['hour'],
        'count': value['count'],
    };
}

